"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var temp = function TagTwoTone(primaryColor, secondaryColor) {
  return {
    name: 'tag',
    theme: 'twotone',
    nameWithTheme: 'tag-twotone',
    tag: 'svg',
    attrs: {
      xmlns: 'http://www.w3.org/2000/svg',
      class: 'icon',
      viewBox: '0 0 1024 1024'
    },
    children: [{
      tag: 'path',
      attrs: {
        fill: secondaryColor,
        d: 'M589 164.6L189.3 564.3l270.4 270.4L859.4 435 836 188l-247-23.4zM680 432c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88z'
      },
      children: []
    }, {
      tag: 'path',
      attrs: {
        d: 'M680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z',
        fill: primaryColor
      },
      children: []
    }, {
      tag: 'path',
      attrs: {
        d: 'M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2c-3.9 3.9-3.9 10.2 0 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9 2.7 0 5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7z',
        fill: primaryColor
      },
      children: []
    }]
  };
};
temp.nameWithTheme = 'tag-twotone';
var TagTwoTone = temp;
exports.default = TagTwoTone;